// MARK: Types
import Style from "types/globals/styleguide/style";
import InitialState, { UpdateStyleguideAction } from "types/redux/styleguide";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const defaultColor = "#1d1d1f";

const initialState: InitialState = {
  colors: {
    error: defaultColor,
    background: "white",
    primary: defaultColor,
    secondary: defaultColor,
    tertiary: defaultColor,
    accent: defaultColor,
  },
  breakpoint: 4,
  isPortrait: false,
  mobile: true,
  innerWidth: 1920,
  innerHeight: 993,
  maximumBlogWidth: 800,
  maximumBodyWidth: 1440,
  containerWidth: 1376,
  margin: 32,
  gutter: 16,
  navigationBarHeight: 80,
};

export const styleguideSlice = createSlice({
  name: UpdateStyleguideAction,
  initialState: initialState,
  reducers: {
    setStyleguide: (state, action: PayloadAction<InitialState>) => {
      state.colors = action.payload.colors;
      state.breakpoint = action.payload.breakpoint;
      state.isPortrait = action.payload.isPortrait;
      state.mobile = action.payload.mobile;
      state.innerWidth = action.payload.innerWidth;
      state.innerHeight = action.payload.innerHeight;
      state.maximumBlogWidth = action.payload.maximumBlogWidth;
      state.maximumBodyWidth = action.payload.maximumBodyWidth;
      state.containerWidth = action.payload.containerWidth;
      state.margin = action.payload.margin;
      state.gutter = action.payload.gutter;
      state.navigationBarHeight = action.payload.navigationBarHeight;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setStyleguide } = styleguideSlice.actions;
// You must export the reducer as follows for it to be able to be read by the store.
export default styleguideSlice.reducer;
